import React from 'react';
import Footer from './Footer';

function Privacy() {
  return (
    <>
      <section id="emailus">
        <div className="container">
          <div className="row">
            <div className="col col-md-12 text-center">
              <h2 className="text-dark">Privacy Policy</h2>
              <hr className="my-4 mx-auto" />
            </div>
          </div>
        </div>
        <div className="container py-2 text-left">
          <div className="row py-1">
            <div className="col">
              <h5>USE OF "PERSONALLY IDENTIFIABLE INFORMATION"</h5>
              <p>
                We do not collect Personally Identifiable Information about you, unless you choose to fill out your information on this 
                website through specific provided forms. In general, you may browse our website without providing any Personallly 
                Identifiable Information about yourself.
              </p>
              <p>
                We use Personally Identifiable Information you provide solely to respond to your inquiry or to process an application 
                form you have completed on our website or to respond to any legal process or as required by law in response to any 
                court order, subpoena or a law enforcement agency or to take action against any illegal activity and to address any 
                potential threat to the physical safety of a person.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>INFORMATION SHARING</h5>
              <p>
                We may share your Personal Identifiable Information within Onedotall, its business partners, subcontractors, 
                service vendors or authorized third-party agents for the purposes of data processing, enrichment, storage, or to 
                facilitate a requested service or work.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>COOKIES AND OTHER TECHNOLOGIES</h5>
              <p>
                We may use cookies, web beacons, tracking pixels, and other tracking technologies on the websiteite to help customize 
                the website and improve your experience. When you access the website, your personal information is NOT collected 
                through the use of tracking technology. Most browsers are set to accept cookies by default. You can remove or reject 
                cookies, but be aware that such action could affect the availability and functionality of the website. 
                You may not decline web beacons. However, they can be rendered ineffective by declining all cookies or by modifying 
                your web browser’s settings to notify you each time a cookie is tendered, permitting you to accept or decline 
                cookies on an individual basis.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>THIRD-PARTY WEBSITES</h5>
              <p>
                The website may contain links to third-party websites and applications of interest, including social media sites, 
                advertisements and external services, that are not affiliated with us. Once you have used these links to leave the 
                website, any information you provide to these third parties is not covered by this Privacy Policy, and we cannot 
                guarantee the safety and privacy of your information.
              </p>
            </div>
          </div>
          <div className="row py-1">
            <div className="col">
              <h5>GRIEVANCE REDRESSAL</h5>
              <p>
                Any grievance or complaint, in relation to processing of information, should be sent to Onedotall in writing to 
                &nbsp;<a href="mailto:0n3.a77@gmail.com">0n3.a77@gmail.com</a>&nbsp;. Grievance shall be redressed as expeditiously as possible. 
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer/>
    </>
  )
}

export default Privacy
